import * as React from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import PdfViewer from '../../utility/PdfViewer';
import PdfViewerModal from "../../utility/PdfViewerModal";
import { handlePdfPreviewScreenOpen } from "../../utility/PdfViewerModal";
import { setSalesForecastSummaryMainElementList } from '../../features/salesForecastSummaryMainElementListSlice';
import '../subPage/SalesForecastSummaryMainElementList/style.css';
import { LOCAL_CONSTANT } from "../Const";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Grid,
    Box,
    Button,
    TableContainer,
    IconButton,
    Typography,
} from '@mui/material';
import { useUtilityContext } from '../../utility-provider';
import { getFileMetadata, uploadFile, deleteUploadFile } from '../../utility/storage';
import SelectModal from '../subPage/SalesForecastSummaryMainElementList/SelectModal';
import { postPython } from '../../api/ApiCall';
import MessageDialog from '../components/MessageDialog';
import {
    setLocationBase
} from '../../features/longPageSlice';
import { getLongPageData } from '../../data/DataManage';
import { useUserContext } from '../../user-provider';
import { locationBaseData } from '../components/LocationBaseFunc';
import dayjs from 'dayjs';
import { DeleteConfirmationModal } from '../ResearchReport/DeleteConfirmationModal';
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import { setPermissionFunc, showHideFunc } from '../components/PermissionFunc';
import { staffName, commonFileDownload, fileExtensionCheck } from '../Common';
import { locationSalesForecastData } from '../components/LocationSalesForecastFunc';
import { setLocationSalesForecastObj } from '../../features/locationSalesForecastSlice';


const templateExcelList = () => {
    return [
        { "template": true, "recreate": 'none', "label": "【" + LOCAL_CONSTANT.LABEL.TEMPORARY_OUTPUT + "】" + LOCAL_CONSTANT.LABEL.SALES_FORECAST_SUMMARY_TABLE, "uploadDate": "", "uplowder": "", "pdfPath": "" },
        { "template": false, "recreate": 'none', "label": LOCAL_CONSTANT.LABEL.SALES_FORECAST_SUMMARY_TABLE, "uploadDate": "", "uplowder": "", "pdfPath": "" },
    ]
}

const headerCell = (type: string) => {
    return{
        backgroundColor: '#D9D9D9',
        fontSize: '12px',
        color: 'black',
        borderBottom: '1px solid black',
        fontWeight: 'Bold',
        width: type === 'FILE_NAME' ? '40%'
        : type === 'UPLOAD_DATE' ? '15%' 
        : type === 'UPLOADER' ? '15%'
        : '6%',
        textAlign: type === 'OTHER' ? 'center' : 'start'
    }
};

export interface salesForecastSummaryMainElementListProps {
    props: {
    }
}

const SalesForecastSummaryMainElementList: React.FC<salesForecastSummaryMainElementListProps> = ({ props }) => {

    const dispatch = useAppDispatch();
    const objflict = useAppSelector((state) => state.salesForecastSummaryMainElementList);
    const handleValueChange = (path: string, labelName: string) => {
        let pdfPath = path

        if(labelName === "pdfPath") {
            if (path) {
                pdfPath = 'gs://' + process.env.REACT_APP_FIREBASE_STORAGE_BUCKET + '/' + objLongPageParam.planAreaId + '/' + objLongPageParam.branch + pdfPath
            }
            pdfPath = objflict.pdfPath === pdfPath ? "" : pdfPath
        } else if (labelName === "fiveYearTrendsFilePath") {
            if (path) {
                pdfPath = 'gs://' + process.env.REACT_APP_FIREBASE_STORAGE_BUCKET + '/' + objLongPageParam.planAreaId + '/' + objLongPageParam.branch + pdfPath
            }
            pdfPath = objflict.fiveYearTrendsFilePath === pdfPath ? "" : pdfPath
        }
        
        //表示中のPDFレコードを押下時非表示
        dispatch(
            setSalesForecastSummaryMainElementList({
                ...objflict,
                [labelName]: pdfPath,
            })
        );
    }
    const [userType, setUserType] = React.useState('');
    const user = useUserContext();
    //ユーザー取得タイミングによる画面制御
    React.useEffect(() => {
        if (JSON.parse(user.userData || 'null') !== null) {
            setUserType(JSON.parse(user.userData || 'null').user_type);
        }
    }, [user]);
    //ロングページオブジェクト
    const objLongPageParam = useAppSelector((state) => state.longPage.param);
    const objLocationBase = useAppSelector((state) => state.longPage.locationBase);
    const objLSalesForecast = useAppSelector((state) => state.locationSalesForecast);

    const utilityCtx = useUtilityContext();
    const [fiveYearTrendsFile, setFiveYearTrendsFile] = React.useState<File | null>(null);
    const [salesForecasFile, setSalesForecasFile] = React.useState<File | null>(null);
    const [message, setMessage] = React.useState<string>("")
    const [recreate, setRecreate] = React.useState<boolean>(false)
    const [hasButton, setHasButton] = React.useState<boolean>(false)
    const [template, setTemplate] = React.useState<boolean>(false)
    const [salesForecastsColor, setSalesForecastsColor] = React.useState<string>("")
    const [open, setOpen] = React.useState<boolean>(false)
    const [messageDialogOpen, setMessageDialogOpen] = React.useState<boolean>(false);
    const [fiveYearTrendsFileList, setFiveYearTrendsFileList] = React.useState<any[]>([]);
    const [excelList, setExcelList] = React.useState<any[]>([]);
    const [fiveYearTrendsDeleteConfModalOpen, setFiveYearTrendsDeleteConfModalOpen] = React.useState(false);
    const [salesForecastDeleteConfModalOpen, setSalesForecastDeleteConfModalOpen] = React.useState(false);
    // 拡張子エラーかどうかを判別するフラグ
    const [isExtensionError, setIsExtensionError] = React.useState<boolean>(false);
    //モーダル開閉フラグ(PDFプレビュー)
    const [pdfPreviewModalFlag, setPdfPreviewModalFlag] = React.useState(false);
    const [pdfPath, setPdfPath] = React.useState<string>("");

    const handleClickFile = (fileType: string) => {
        let fileElem;
        if(fileType === "fiveYearTrendsFile") {
            fileElem = document.getElementById("fiveYearTrendsFileElem");
        } else if (fileType === "tempSalesForecasFile") {
            setTemplate(true);
            fileElem = document.getElementById("salesForecasFileElem");
        } else if (fileType === "salesForecasFile") {
            setTemplate(false);
            fileElem = document.getElementById("salesForecasFileElem");
        }
        if (fileElem) {
            fileElem.click()
        }
    }

    const handleChangeFiveYearTrendsFile = (newFile: any) => {
        // ファイル拡張子チェック（.xlsxと.xlsmのみ許可）
        if (
            fileExtensionCheck(
                newFile.target.files[0],
                LOCAL_CONSTANT.FILE_EXTENSIONS.EXCEL_XLSX_XLSM,
                setMessageDialogOpen,
                setMessage,
                setHasButton,
                LOCAL_CONSTANT.CONFIRM_MESSAGE.EXTENSION_CHECK_XLSX_XLSM
            )
        ) {
            setFiveYearTrendsFile(newFile.target.files[0]);
        } else {
            // 拡張子エラーの場合はフラグを設定
            setIsExtensionError(true);
        }
        newFile.target.value = '';
    };

    const handleChangeSalesForecasFile = (newFile: any) => {
        setSalesForecasFile(newFile.target.files[0]);
        newFile.target.value = '';
    };

    React.useEffect(() => {
        if (fiveYearTrendsFile) {
            fiveYearTrendsFileUpload();
        }
    }, [fiveYearTrendsFile]);

    React.useEffect(() => {
        if (salesForecasFile) {
            setOpen(true)
        }
    }, [salesForecasFile]);

    const handleRecreate = (template: boolean) => {
        handleValueChange("", 'pdfPath')
        setTemplate(template)
        setRecreate(true)
        setOpen(true)
    }

    React.useEffect(() => {
        if(objLocationBase) {
            setFiveYearTrendsFileList(objLocationBase.trends_file_path);
        }
    },[objLocationBase]);

    React.useEffect(() => {
        if (objLSalesForecast) {
            setExcelList(templateExcelList)
        }
    }, [objLSalesForecast])

    React.useEffect(() => {
        if (excelList.length > 0 && objLongPageParam.planAreaId) {
            setExcelList(templateExcelList)
            objLSalesForecast.obj.map((row: any) => {
                if (row.sales_forecast_pdf_path) {
                    let index = 0
                    let label = 'temp_sales_forecast_upload_date'
                    if (row.temp_flag === '0') {
                        index = 1
                        label = 'sales_forecast_upload_date'
                    }
                    excelList[index]['recreate'] = 'block'
                    excelList[index]['pdfPath'] = row.sales_forecast_pdf_path
                    excelList[index]['uplowder'] = row.sales_forecast_upload_user
                    getFile(row.sales_forecast_pdf_path, index, label)
                }
            })
            setExcelList(excelList)
        }
    }, [excelList, objLongPageParam])

    const getFile = (filePath: string, index: number, labelName: string) => {
        (async () => {
            const path = '/' + objLongPageParam.planAreaId + '/' + objLongPageParam.branch + filePath
            await getFileMetadata(path)
                .then((fileData: any) => {
                    excelList[index]['uploadDate'] = fileData.updated
                    dispatch(
                        setSalesForecastSummaryMainElementList({
                            ...objflict,
                            [labelName]: fileData.updated,
                        })
                    );
                })
        })();
    }

    const showUploadDate = (param: any) => {
        let date = ""
        if (param) {
            date = dayjs(param).format('YYYY/MM/DD HH:mm:ss')
        }
        return date
    }

    //ファイル保存
    const fileDownload = (filePath: string, fileName: string) => {
        commonFileDownload('/' + objLongPageParam.planAreaId + '/' + objLongPageParam.branch + filePath, fileName + '.pdf')
    }

    //5年間推移UL処理
    const fiveYearTrendsFileUpload = () => {
        if(fiveYearTrendsFile) {
            const userData = JSON.parse(user.userData);
            const upload_date = dayjs().format('YYYY/MM/DD HH:mm:ss');
            const params = {
                mode: "regist",
                endPoint: "/excel-to-pdf-fiveYearTrends",
                query: {
                    mode: "create",
                    prop_site_no: objLongPageParam.planAreaId,
                    branch: objLongPageParam.branch,
                    file_name: fiveYearTrendsFile.name,
                    upload_date: upload_date,
                    upload_user_id: userData.staff_number,
                    upload_user_name: staffName(userData.staff_number),
                    location_type: objLocationBase.location_type,
                }
            };
            if (utilityCtx.showSpinner) {
                utilityCtx.showSpinner();
            }
            (async () => {
                try {
                    setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.CREATE_PDF)
                    setMessageDialogOpen(true)
                    //既存のアップロードファイルを削除
                    let deleteFile = null;
                    fiveYearTrendsFileList.map(async (row: any) => {
                        if (objLocationBase.location_type === row.location_type) {
                            // excel削除
                            deleteFile = await getFileMetadata("/" + objLongPageParam.planAreaId + "/" + objLongPageParam.branch + row.excel_path);
                            await deleteUploadFile(deleteFile, "/" + objLongPageParam.planAreaId + "/" + objLongPageParam.branch + row.excel_path)
                            // pdf削除
                            deleteFile = await getFileMetadata("/" + objLongPageParam.planAreaId + "/" + objLongPageParam.branch + row.pdf_path);
                            await deleteUploadFile(deleteFile, "/" + objLongPageParam.planAreaId + "/" + objLongPageParam.branch + row.pdf_path)
                        }
                    })
                    await uploadFile(fiveYearTrendsFile, objLongPageParam.planAreaId + '/' + objLongPageParam.branch + '/excel/trends/'+ objLocationBase.location_type + "/" + fiveYearTrendsFile.name)
                    await postPython(params)
                    setFiveYearTrendsFile(null)
                    setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.COMPLETE_CREATE_PDF)
                    setHasButton(true)
                    if (utilityCtx.hideSpinner) {
                        utilityCtx.hideSpinner();
                    }
                } catch (e) {
                    console.log(e);
                    setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.UNCOMPLETE_CREATE_PDF)
                    setHasButton(true)
                    if (utilityCtx.hideSpinner) {
                        utilityCtx.hideSpinner();
                    }
                }
            })();
        }
    }

    //売上予測集計表UL処理
    const salesForecasFileUpload = (hasRecreate: boolean) => {
        const userData = JSON.parse(user.userData)
        const upload_file_name = template
            ? LOCAL_CONSTANT.LABEL.TEMPORARY_OUTPUT + '_' + LOCAL_CONSTANT.LABEL.SALES_FORECAST_SUMMARY_TABLE
            : LOCAL_CONSTANT.LABEL.SALES_FORECAST_SUMMARY_TABLE
        const params = {
            mode: "regist",
            endPoint: "/excel-to-pdf",
            query: {
                prop_site_no: objLongPageParam.planAreaId,
                branch: objLongPageParam.branch,
                file_name: upload_file_name + '.xlsx',
                manager: "",
                color: salesForecastsColor,
                temp_flag: template ? '1' : '0',
                isInei: hasRecreate ? '1' : '0',
                mode: recreate ? "recreate" : "create",
                approval_type: "",
                approval_user: userData.user_name,
                approval_department: userData.user_name,
                user_data: {
                    update_top_department: userData.top_department_code_OA,
                    update_department: userData.department_code_OA,
                    update_job: userData.job_category_code_OA,
                    update_mail: userData.email.toString(),
                    update_stuff_number: userData.staff_number,
                    update_name: userData.user_name
                }
            }
        };
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.CREATE_PDF)
                setMessageDialogOpen(true)
                if (!hasRecreate) {
                    const uploadResult = await uploadFile(salesForecasFile, objLongPageParam.planAreaId + '/' + objLongPageParam.branch + '/excel/' + upload_file_name + '.xlsx')
                }
                const result = await postPython(params)
                setSalesForecasFile(null)
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.COMPLETE_CREATE_PDF)
                setHasButton(true)
                setRecreate(false)
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            } catch (e) {
                console.log(e);
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.UNCOMPLETE_CREATE_PDF)
                setHasButton(true)
                setRecreate(false)
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    }

    const getLocationSalesForecastAndFiveYearTrends = () => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        try {
            // API呼び出し
            callApi('getLocationSalesForecastAndFiveYearTrends').then((res: any) => {
                dispatch(setLocationSalesForecastObj(locationSalesForecastData(res.getLocationSalesForecast)));
                dispatch(setLocationBase(locationBaseData(res.getLocationBase)));
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }).catch((e) => {
                console.log(e)
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            })
        } catch (e) {
            console.log(e)
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        }
    }

    const callApi = async (target: string) => {
        if (target === 'getLocationSalesForecastAndFiveYearTrends') {
            // テストデータ固定値
            const param: any = [
                {
                    mode: 'getLocationSalesForecast',
                    plan_area_id: objLongPageParam.planAreaId,
                    branch: objLongPageParam.branch,
                },
                {
                    mode: "getLocationBase",
                    plan_area_id: objLongPageParam.planAreaId,
                    branch: objLongPageParam.branch,
                }
            ];
            return await getLongPageData(param);
        }
    };

    //PDFプレビューモーダルオープン
    const handlePdfPreviewModalOpen = (pdfPathParam: string) => {
        setPdfPreviewModalFlag(true);
        setPdfPath(pdfPathParam);
    };

    // PDF作成モダールクローズ後
    const closeMessageDialog = () => {
        setMessage("")
        setHasButton(false)
        setMessageDialogOpen(false)
        
        // 拡張子エラーの場合はAPI呼び出しをスキップ
        if (!isExtensionError) {
            getLocationSalesForecastAndFiveYearTrends()
        }
        setIsExtensionError(false) // フラグをリセット
    }
    /* const templateDisplay: boolean = (
        objLocationBase.task_id === 'C006' && userType === LOCAL_CONSTANT.USER_TYPE.RR
    )
    const salesForecasDisplay: boolean = (
        objLocationBase.task_id === 'B010' && userType === LOCAL_CONSTANT.USER_TYPE.RR
    ) */

    //削除確認用モーダル表示 5年間推移
    const handleFiveYearTrendsDeleteConfModalOpen = () => {
        setFiveYearTrendsDeleteConfModalOpen(true);
    };

    //ファイル削除 5年間推移
    const handleFiveYearTrendsDeleteChange = () => {
        handleValueChange("", 'fiveYearTrendsFilePath');
        deleteFiveYearTrendsFile();
    };

    const deleteFiveYearTrendsFile = () => {
        const userData = JSON.parse(user.userData)
        const params = {
            mode: "regist",
            endPoint: "/excel-to-pdf-fiveYearTrends",
            query: {
                mode: "delete",
                prop_site_no: objLongPageParam.planAreaId,
                branch: objLongPageParam.branch,
                location_type: objLocationBase.location_type,
                user_data: {
                    update_top_department: userData.top_department_code_OA,
                    update_department: userData.department_code_OA,
                    update_job: userData.job_category_code_OA,
                    update_mail: userData.email.toString(),
                    update_stuff_number: userData.staff_number,
                    update_name: userData.user_name
                }
            }
        };
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.DELETE_PDF)
                setMessageDialogOpen(true)
                // ファイル削除
                //既存のアップロードファイルを削除
                let deleteFile = null;
                fiveYearTrendsFileList.map(async (row: any) => {
                    if (objLocationBase.location_type === row.location_type) {
                        // excel削除
                        deleteFile = await getFileMetadata("/" + objLongPageParam.planAreaId + "/" + objLongPageParam.branch + row.excel_path);
                        await deleteUploadFile(deleteFile, "/" + objLongPageParam.planAreaId + "/" + objLongPageParam.branch + row.excel_path)
                        // pdf削除
                        deleteFile = await getFileMetadata("/" + objLongPageParam.planAreaId + "/" + objLongPageParam.branch + row.pdf_path);
                        await deleteUploadFile(deleteFile, "/" + objLongPageParam.planAreaId + "/" + objLongPageParam.branch + row.pdf_path)
                    }
                })
                await postPython(params)
                setFiveYearTrendsFile(null)
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.SUCCESS_DELETE_PDF)
                setHasButton(true)
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            } catch (e) {
                console.log(e);
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.ERROR_DELETE_PDF)
                setHasButton(true)
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    };

    //削除確認用モーダル表示  売上予測集計表
    const handleSalesForecastDeleteConfModalOpen = (rowData: any) => {
        setSalesForecastDeleteConfModalOpen(true);
        setTemplate(rowData.template)
    }

    //ファイル削除 売上予測集計表
    const handleSalesForecastDeleteChange = () => {
        handleValueChange("", 'pdfPath');
        deleteSalesForecastFile();
    }

    const deleteSalesForecastFile = () => {
        const userData = JSON.parse(user.userData)
        const temp_flag = template ? '1' : '0'
        const params = {
            mode: "regist",
            endPoint: "/excel-to-pdf",
            query: {
                prop_site_no: objLongPageParam.planAreaId,
                branch: objLongPageParam.branch,
                file_name: '',
                manager: "",
                color: salesForecastsColor,
                temp_flag: temp_flag,
                isInei: '0',
                mode: "delete",
                approval_type: "",
                approval_user: '',
                approval_department: '',
                user_data: {
                    update_top_department: userData.top_department_code_OA,
                    update_department: userData.department_code_OA,
                    update_job: userData.job_category_code_OA,
                    update_mail: userData.email.toString(),
                    update_stuff_number: userData.staff_number,
                    update_name: userData.user_name
                }
            }
        };
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.DELETE_PDF)
                setMessageDialogOpen(true)
                // ファイル削除
                let sales_forecast_excel_path = ""
                let sales_forecast_pdf_path = ""
                let deleteFile = null
                const path = '/' + objLongPageParam.planAreaId + '/' + objLongPageParam.branch + '/'
                objLSalesForecast.obj.map(async (row: any) => {
                    if (temp_flag === row.temp_flag) {
                        // excel削除
                        deleteFile = await getFileMetadata(path + row.sales_forecast_excel_path);
                        await deleteUploadFile(deleteFile, path + row.sales_forecast_excel_path)
                        // pdf削除
                        deleteFile = await getFileMetadata(path + row.sales_forecast_pdf_path);
                        await deleteUploadFile(deleteFile, path + row.sales_forecast_pdf_path)
                    }
                })
                await postPython(params)
                setSalesForecasFile(null)
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.SUCCESS_DELETE_PDF)
                setHasButton(true)
                setRecreate(false)
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            } catch (e) {
                console.log(e);
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.ERROR_DELETE_PDF)
                setHasButton(true)
                setRecreate(false)
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    }

    return (
        <Box sx={{ width: "100%", margin: "30px" }}>
            <input
                id="fiveYearTrendsFileElem"
                type="file"
                style={{ display: 'none' }}
                onChange={handleChangeFiveYearTrendsFile}
                accept=".xlsx,.xlsm"
            />
            <input
                id="salesForecasFileElem"
                type="file"
                style={{ display: 'none' }}
                onChange={handleChangeSalesForecasFile}
                accept=".xlsx"
            />
            {/* 5年間推移 */}
            {(
                objLocationBase.location_type === "02" || 
                objLocationBase.location_type === "03" ||
                objLocationBase.location_type === "04"
            ) && (
                <>
                    <Typography
                        sx={{
                            marginRight: "20px",
                            marginTop: "40px",
                            alignSelf: "flex-start",
                            whiteSpace: "nowrap",
                            fontWeight: "bold",
                        }}
                    >
                        {LOCAL_CONSTANT.NAVI.FIVE_YEAR_TRENDS}
                    </Typography>
                    {showHideFunc(userType, objLocationBase.task_id, LOCAL_CONSTANT.NAVI.FIVE_YEAR_TRENDS, 'uploadButton') &&
                        <Box>
                            <Button
                                sx={{ margin: '20px 0' }}
                                variant="contained"
                                color="success"
                                size="small"
                                onClick={(e) => { handleClickFile("fiveYearTrendsFile") }}
                                disabled={setPermissionFunc(userType, objLocationBase.task_id, LOCAL_CONSTANT.NAVI.FIVE_YEAR_TRENDS, 'uploadButton')}
                            >{
                                LOCAL_CONSTANT.NAVI.FIVE_YEAR_TRENDS +
                                LOCAL_CONSTANT.LABEL.UPLOAD
                            }</Button>
                        </Box>
                    }
                    <Grid container spacing={1}>
                        <Grid item xs={12} sx={{ paddingRight: "40px" }}>
                            <TableContainer sx={{ width: "100%", border: '1px solid black' }}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={headerCell("FILE_NAME")}>{LOCAL_CONSTANT.LABEL.FILE_NAME}</TableCell>
                                            <TableCell sx={headerCell("UPLOAD_DATE")}>{LOCAL_CONSTANT.LABEL.UPLOAD_DATE}</TableCell>
                                            <TableCell sx={headerCell("UPLOADER")}>{LOCAL_CONSTANT.LABEL.UPLOADER}</TableCell>
                                            <TableCell sx={headerCell("OTHER")}></TableCell>
                                            <TableCell sx={headerCell("OTHER")}></TableCell>
                                            <TableCell sx={headerCell("OTHER")}>Excel</TableCell>
                                            <TableCell sx={headerCell("OTHER")}>PDF</TableCell>
                                            <TableCell sx={headerCell("OTHER")}></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {fiveYearTrendsFileList.map((val, index) => (
                                            <TableRow className="tableRow" key={index}>
                                                {(val.location_type  === objLocationBase.location_type) && (
                                                    <>    
                                                        <TableCell onClick={() => handleValueChange(val.pdf_path, "fiveYearTrendsFilePath")}>{val.file_name}</TableCell>
                                                        <TableCell onClick={() => handleValueChange(val.pdf_path, "fiveYearTrendsFilePath")}>{showUploadDate(val.upload_date)}</TableCell>
                                                        <TableCell onClick={() => handleValueChange(val.pdf_path, "fiveYearTrendsFilePath")}>{staffName(val.upload_user_name)}</TableCell>
                                                        <TableCell sx={{ textAlign: "center" }}>
                                                            {val.pdf_path !== "" && (
                                                                <IconButton
                                                                    sx={{ color: 'black' }} 
                                                                    onClick={() =>
                                                                        handlePdfPreviewModalOpen(
                                                                            "/" + objLongPageParam.planAreaId + "/" + objLongPageParam.branch + val.pdf_path
                                                                        )
                                                                    }
                                                                >
                                                                    <PictureAsPdfIcon />
                                                                </IconButton>
                                                            )}
                                                        </TableCell>
                                                        <TableCell sx={{ textAlign: "center" }}>
                                                            {val.pdf_path !== "" && (
                                                                <IconButton
                                                                    sx={{ color: 'black' }} 
                                                                    onClick={() =>
                                                                        handlePdfPreviewScreenOpen(
                                                                            "/" + objLongPageParam.planAreaId + "/" + objLongPageParam.branch + val.pdf_path
                                                                        )
                                                                    }
                                                                >
                                                                    <OpenInNewIcon />
                                                                </IconButton>
                                                            )}
                                                        </TableCell>
                                                        <TableCell  sx={{ textAlign: "center" }}>
                                                            {val.excel_path !== "" && (
                                                                <IconButton 
                                                                    sx={{ color: 'black' }} 
                                                                    onClick={() => {
                                                                        // val.excel_pathから拡張子を抽出
                                                                        const extension = "." + val.excel_path.split(".").pop();
                                                                        commonFileDownload("/" + objLongPageParam.planAreaId + "/" + objLongPageParam.branch + val.excel_path, val.file_name + extension);
                                                                    }}
                                                                    ><DownloadIcon />
                                                                </IconButton>
                                                            )}
                                                        </TableCell>
                                                        <TableCell  sx={{ textAlign: "center" }}>
                                                            {val.pdf_path !== "" && (
                                                                <IconButton 
                                                                    sx={{ color: 'black' }} 
                                                                    onClick={() => {
                                                                        // val.pdf_pathから拡張子を抽出
                                                                        const extension = "." + val.pdf_path.split(".").pop();
                                                                        commonFileDownload("/" + objLongPageParam.planAreaId + "/" + objLongPageParam.branch + val.pdf_path, val.file_name + extension);
                                                                    }}
                                                                    ><DownloadIcon />
                                                                </IconButton>
                                                            )}
                                                        </TableCell>
                                                        <TableCell  sx={{ textAlign: "center" }}>
                                                            {val.pdf_path !== "" && (
                                                                <IconButton 
                                                                    sx={{ color: 'black' }} 
                                                                    onClick={() => handleFiveYearTrendsDeleteConfModalOpen()}
                                                                    disabled={setPermissionFunc(userType, objLocationBase.task_id, LOCAL_CONSTANT.NAVI.FIVE_YEAR_TRENDS, 'deleteButton')}
                                                                    ><DeleteIcon />
                                                                </IconButton>
                                                            )}
                                                        </TableCell>
                                                    </>
                                                )}
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                    {objflict.fiveYearTrendsFilePath !== "" &&
                        <Box sx={{ padding: "30px 40px 0px 0px" }}>
                            <PdfViewer props={{ pdfPath: objflict.fiveYearTrendsFilePath }} />
                        </Box>
                    }
                </>
            )}
            {/* 売上予測集計表 */}
            {showHideFunc(userType, objLocationBase.task_id, LOCAL_CONSTANT.NAVI.SALES_FORECAST_SUMMARY_MAIN_ELEMENT_LIST, 'tempUploadButton') &&
                <Box>
                    <Button
                        sx={{ margin: '20px 0' }}
                        variant="contained"
                        color="success"
                        size="small"
                        onClick={(e) => { handleClickFile("tempSalesForecasFile") }}
                        disabled={setPermissionFunc(userType, objLocationBase.task_id, LOCAL_CONSTANT.NAVI.SALES_FORECAST_SUMMARY_MAIN_ELEMENT_LIST, 'tempUploadButton')}
                    >{"【" + LOCAL_CONSTANT.LABEL.TEMPORARY_OUTPUT + "】" +
                        LOCAL_CONSTANT.LABEL.SALES_FORECAST_SUMMARY_TABLE +
                        LOCAL_CONSTANT.LABEL.UPLOAD}</Button>
                </Box>
            }
            {showHideFunc(userType, objLocationBase.task_id, LOCAL_CONSTANT.NAVI.SALES_FORECAST_SUMMARY_MAIN_ELEMENT_LIST, 'uploadButton') &&
                <Box>
                    <Button
                        sx={{ margin: '20px 0' }}
                        variant="contained"
                        color="success"
                        size="small"
                        onClick={(e) => { handleClickFile("salesForecasFile") }}
                        disabled={setPermissionFunc(userType, objLocationBase.task_id, LOCAL_CONSTANT.NAVI.SALES_FORECAST_SUMMARY_MAIN_ELEMENT_LIST, 'uploadButton')}
                    >{LOCAL_CONSTANT.LABEL.SALES_FORECAST_SUMMARY_TABLE + LOCAL_CONSTANT.LABEL.UPLOAD}</Button>
                </Box>
            }
            <SelectModal
                props={{
                    open: open,
                    handleModal: setOpen,
                    handleRegistColor: setSalesForecastsColor,
                    handleRegistModal: salesForecasFileUpload,
                    recreate: recreate
                }} />
            <MessageDialog props={{
                open: messageDialogOpen,
                handleModal: closeMessageDialog,
                body: message,
                hasButton: hasButton,
                buttonBody: LOCAL_CONSTANT.LABEL.CLOSE,
            }}
            />
            <Grid container spacing={1}>
                <Grid item xs={12} sx={{ paddingRight: "40px" }}>
                    <TableContainer sx={{ width: "100%", border: '1px solid black' }}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={headerCell("FILE_NAME")}></TableCell>
                                    <TableCell sx={headerCell("UPLOAD_DATE")}>{LOCAL_CONSTANT.LABEL.UPLOAD_DATE}</TableCell>
                                    <TableCell sx={headerCell("UPLOADER")}>{LOCAL_CONSTANT.LABEL.UPLOADER}</TableCell>
                                    <TableCell sx={headerCell("OTHER")}>{LOCAL_CONSTANT.LABEL.PDF_CREATION}</TableCell>
                                    <TableCell sx={headerCell("OTHER")}></TableCell>
                                    <TableCell sx={headerCell("OTHER")}></TableCell>
                                    <TableCell sx={headerCell("OTHER")}></TableCell>
                                    <TableCell sx={headerCell("OTHER")}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {excelList.map((val, index) => (
                                    <TableRow className="tableRow" key={index}>
                                        <TableCell onClick={() => handleValueChange(val.pdfPath, "pdfPath")}>{val.label}</TableCell>
                                        <TableCell onClick={() => handleValueChange(val.pdfPath, "pdfPath")}>{showUploadDate(val.uploadDate)}</TableCell>
                                        <TableCell onClick={() => handleValueChange(val.pdfPath, "pdfPath")}>{staffName(val.uplowder)}</TableCell>
                                        <TableCell  sx={{ textAlign: "center" }}>
                                            {val.recreate == 'block' && (
                                                <Button
                                                    variant="contained"
                                                    color="success"
                                                    size="small"
                                                    onClick={(e) => { handleRecreate(val.template) }}
                                                    disabled={setPermissionFunc(userType, objLocationBase.task_id, LOCAL_CONSTANT.NAVI.SALES_FORECAST_SUMMARY_MAIN_ELEMENT_LIST, 'recreateButton')}
                                                >{LOCAL_CONSTANT.LABEL.RECREATE}</Button>
                                            )}
                                        </TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>
                                            {val.pdfPath !== "" && (
                                                <IconButton
                                                    sx={{ color: 'black' }} 
                                                    onClick={() =>
                                                        handlePdfPreviewModalOpen(
                                                            '/' + objLongPageParam.planAreaId + 
                                                            '/' + objLongPageParam.branch +
                                                            "/" + val.pdfPath
                                                        )
                                                    }
                                                >
                                                    <PictureAsPdfIcon />
                                                </IconButton>
                                            )}
                                        </TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>
                                            {val.pdfPath !== "" && (
                                                <IconButton
                                                    sx={{ color: 'black' }} 
                                                    onClick={() =>
                                                        handlePdfPreviewScreenOpen(
                                                            '/' + objLongPageParam.planAreaId + 
                                                            '/' + objLongPageParam.branch +
                                                            "/" + val.pdfPath
                                                        )
                                                    }
                                                >
                                                    <OpenInNewIcon />
                                                </IconButton>
                                            )}
                                        </TableCell>
                                        <TableCell  sx={{ textAlign: "center" }}>
                                            {val.pdfPath !== "" && (
                                                <IconButton 
                                                    sx={{ color: 'black' }} 
                                                    onClick={() => fileDownload(val.pdfPath, val.label)}
                                                    ><DownloadIcon />
                                                </IconButton>
                                            )}
                                        </TableCell>
                                        <TableCell  sx={{ textAlign: "center" }}>
                                            {val.pdfPath !== "" && (
                                                <IconButton 
                                                    sx={{ color: 'black' }} 
                                                    onClick={() => handleSalesForecastDeleteConfModalOpen(val)}
                                                    disabled={setPermissionFunc(userType, objLocationBase.task_id, LOCAL_CONSTANT.NAVI.SALES_FORECAST_SUMMARY_MAIN_ELEMENT_LIST, 'deleteButton')}
                                                    ><DeleteIcon />
                                                </IconButton>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>

            {objflict.pdfPath !== "" &&
                <Box sx={{ padding: "30px 40px 0px 0px" }}>
                    <PdfViewer props={{ pdfPath: objflict.pdfPath }} />
                </Box>
            }

            {/* 削除確認モーダル 予測集計表 */}
            <DeleteConfirmationModal modalOpen={salesForecastDeleteConfModalOpen} setModalOpen={setSalesForecastDeleteConfModalOpen} deleteMethod={handleSalesForecastDeleteChange} />

            {/* 削除確認モーダル 5年間推移*/}
            <DeleteConfirmationModal modalOpen={fiveYearTrendsDeleteConfModalOpen} setModalOpen={setFiveYearTrendsDeleteConfModalOpen} deleteMethod={handleFiveYearTrendsDeleteChange} />

            {/* PDFプレビューモーダル */}
            <PdfViewerModal
                props={{
                    open: pdfPreviewModalFlag,
                    setOpen: setPdfPreviewModalFlag,
                    pdfPath: pdfPath,
                }}
            />
        
        </Box>
    );

}

export default SalesForecastSummaryMainElementList;
